<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Partecipanti',
      link: '/partecipanti'
    }, {
      label: 'Gestisci Gruppi di Partecipanti'
    }]"
  />

  <form autocomplete="off">
    <div
      v-for="companyGroup in companyGroups"
      :key="'company-company-group-' + companyGroup.uuid"
    >
      <InputBoolean
        v-model="form[companyGroup.uuid]"
        :error-fields="[]"
        :name="companyGroup.name"
        :submitted="false"
      >
        {{ companyGroup.name }}
      </InputBoolean>
    </div>
    <SubmitButtons
      mode="update"
      :pending="pending"
      :update="update"
    />
  </form>
</template>

<script setup>
import { reactive,ref } from 'vue'
import { useRouter } from 'vue-router';

import InputBoolean from '@/components/form/InputBoolean.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios';
import { useNotificationsStore } from '@/stores/notifications';

const props = defineProps({
  id: {
    required: true,
    type: String
  }
})

const axios = useAxios()
const notificationStore = useNotificationsStore()
const router = useRouter()

const pending = ref(false);

const companyGroupResp = await axios.get('/company-group/list');
const companyGroups = ref(companyGroupResp.data)

const resp = await axios.get('/company/' + props.id);
const companyCompanyGroups = resp.data.companyGroups

const form = reactive(companyGroups.value.reduce((carry, companyGroup) => {
  carry[companyGroup.uuid] = companyCompanyGroups.includes(companyGroup.uuid)
  return carry;
}, {}))

const update = async () => {
  pending.value = true;
  try {
    await axios.post('/company/' + props.id + '/company-group', { uuids: Object.keys(form).filter((key) => form[key]) })

    notificationStore.pushSuccess('Partecipante aggiornato con successo');
    router.push('/partecipanti');
  } catch (e) {
    pending.value = false;
    throw e
  }
}

</script>